import { render, staticRenderFns } from "./BuyBoxNoOffersNew.vue?vue&type=template&id=e9b08fee&scoped=true"
import script from "./BuyBoxNoOffersNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxNoOffersNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxNoOffersNew.vue?vue&type=style&index=0&id=e9b08fee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b08fee",
  null
  
)

export default component.exports